export const MARKETING_CATEGORIES: string[] = [
  "Branding",
  "Digital marketing",
  "TV commercials",
  "Cinemas advertising",
  "Airports billboards",
  "Taxis & buses advertising",
  "Metro stations advertising",
  "Radio advertising",
  "Building & street billboards",
  "Event planning",
  "Influencers marketing",
  "Sports",
  "Production",
  "Indoor screens",
  "Printing",
  "Corporate gifts",
  "Creative",
  "Others",
];
